function renderReCaptcha() {
    for (var i = 0; i < document.forms.length; ++i) {
      var form = document.forms[i];
      var holder = form.querySelector('.invisible-recaptcha');
      if (null === holder) continue;
      (function(frm) {
        var holderId = grecaptcha.render(holder, {
          'sitekey': '6LcI62UaAAAAAMdfLP21Qtgqy9wv7NkUfdaDu6OK',
          'badge': 'inline', // or 'badge'
          'size': 'invisible',
          'callback': function(recaptchaToken) {
            HTMLFormElement.prototype.submit.call(frm);
          },
          'expired-callback': function() {
            grecaptcha.reset(holderId);
          }
        });
        frm.onsubmit = function(evt) {
          evt.preventDefault();
          grecaptcha.execute(holderId);
        };
      })(form);
    }
  };

  window.renderReCaptcha = renderReCaptcha; $(document).ready(function() {
    $('input:not(.hasDatepicker), textarea').on('focus', function() {
      // trigger loading api.js (recaptcha.js) script
      var head = document.getElementsByTagName('head')[0];
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://www.google.com/recaptcha/api.js?onload=renderReCaptcha&render=explicit';
      head.appendChild(script);
      // remove focus to avoid js error:
      // Uncaught Error: reCAPTCHA has already been rendered in this element at Object.kh
      $('input').off('focus');
    });
  });
